import utils from '../utils';

/**
 * Renders a plain text row for display from a complex object that has keys for values.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {Array}
 */
export default function complexColumn({cachedColumn, rowData, createElement}) {
    const values = utils.getCellValues({cachedColumn, rowData});
    const {map = v => v} = cachedColumn.props;
    const safeMap = (v) => {
        try {
            return map(v);
        } catch (error) {
            return utils.emptyInnerHTML;
        }
    };
    const children = values.length
        ? values.map(safeMap).join(utils.joinDelimiter)
        : [utils.getEmptyCellElement(createElement)];
    const title = values.length ? children : utils.emptyInnerHTML;
    return [
        'div',
        {
            attrs: {title},
        },
        children,
    ];
}
